import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'glxy-transcript-entry-loading-state',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './transcript-entry-loading-state.component.html',
  styleUrls: ['./transcript-entry-loading-state.component.scss'],
})
export class TranscriptEntryLoadingStateComponent {}
